import moment from 'moment';
import { MARIAFILO, FOXTON } from './brands';

const MARIA_FILO_AND_FOXTON_NEW_RANGE = moment('2026-03-01');
const MF_COMP_02_START = moment('2026-01-26');
const MF_COMP_02_END = moment('2026-02-28');

export default (date, brandId) => {
    if ([MARIAFILO, FOXTON].includes(Number(brandId))) {
        if (moment().isSameOrAfter(MARIA_FILO_AND_FOXTON_NEW_RANGE, 'day')) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }

        // Período especial: aplica apenas se a data estiver entre 26/jan e 28/fev
        // e não for um dia anterior ao dia 26 dentro do mês de janeiro
        const isInSpecialPeriod =
            moment(date).isSameOrAfter(MF_COMP_02_START, 'day') &&
            moment(date).isSameOrBefore(MF_COMP_02_END, 'day') &&
            !(
                moment(date).month() === MF_COMP_02_START.month() &&
                moment(date).date() < MF_COMP_02_START.date()
            );

        if (isInSpecialPeriod) {
            return {
                startDate: MF_COMP_02_START.clone(),
                endDate: MF_COMP_02_END.clone(),
            };
        }
        let day = moment(date);
        if (day.date() >= 26) {
            day = day.add(1, 'month');
        }
        return {
            startDate: day
                .clone()
                .subtract(1, 'month')
                .date(26),
            endDate: day.clone().date(25),
        };
    }

    if (Number(brandId) === 16) {
        if (
            date.isBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(7)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }
        if (
            date.isSameOrBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(8)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).date(25),
            };
        }
        if (
            date.isAfter(
                moment()
                    .hour(0)
                    .date(1)
                    .month(8)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }
    } else {
        if (
            date.isBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(4)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }
        if (
            date.isSameOrBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(5)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).date(25),
            };
        }
        if (
            date.isAfter(
                moment()
                    .hour(0)
                    .date(1)
                    .month(5)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }
    }
};
